var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutBase", [
    _c(
      "header",
      { attrs: { id: "content__header" } },
      [
        _vm.resource.creator
          ? _c("UserCard", {
              attrs: { user: _vm.resource.creator, borderless: true },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.resource.can.edit
          ? _c(
              "router-link",
              {
                staticClass: "btn btn--primary",
                attrs: {
                  to: {
                    name: "intelligence-preview",
                    params: { intelligence_id: _vm.resource.id },
                  },
                },
              },
              [_vm._v("Edit\n\t\t")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("ul", { staticClass: "grid post-details" }, [
      _vm.resource.createdAt
        ? _c("li", { staticClass: "col-6 col-md-3 detail" }, [
            _c("span", { staticClass: "label" }, [_vm._v("Posted")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "h3" },
              [
                _c("SvgIcon", { attrs: { icon: "calendar" } }),
                _vm._v(" " + _vm._s(_vm.resource.createdAt)),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.resource.dealType
        ? _c("li", { staticClass: "col-12 col-md-3 detail" }, [
            _c("span", { staticClass: "label" }, [_vm._v("Deal Type")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "h3" },
              [
                _c("SvgIcon", { attrs: { icon: "deal" } }),
                _vm._v(" " + _vm._s(_vm.resource.dealType)),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.resource.sectors
        ? _c(
            "li",
            { staticClass: "col-12 col-md-9 detail" },
            [
              _c("span", { staticClass: "label" }, [_vm._v("Sectors")]),
              _vm._v(" "),
              _vm._l(_vm.resource.sectors, function (sector) {
                return _c("span", { staticClass: "sector" }, [
                  _vm._v(_vm._s(sector.name)),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.resource.content
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "header" }, [_vm._v("Intel")]),
          _vm._v(" "),
          _c("div", { domProps: { innerHTML: _vm._s(_vm.resource.content) } }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }